import { render, staticRenderFns } from "./BusinessOpportunityNewsCard.vue?vue&type=template&id=9f354196&scoped=true&"
import script from "./BusinessOpportunityNewsCard.vue?vue&type=script&lang=js&"
export * from "./BusinessOpportunityNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOpportunityNewsCard.vue?vue&type=style&index=0&id=9f354196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f354196",
  null
  
)

export default component.exports